import { Easing, Tween, ViewerModule } from "@g.frame/core";
import { CircleBufferGeometry, Group, Mesh, MeshBasicMaterial } from "three";
export default class ProgressCircle extends ViewerModule {
    constructor(radius) {
        super();
        this.radius = radius;
        this.animate = () => {
            const endAngle = (Math.PI * 2 * 17 / 18);
            new Tween({ alpha: 0 }).to({ alpha: 1 }, 9000)
                .easing(Easing.Quadratic.InOut)
                .onUpdate((alpha) => {
                this.updateSectors(-alpha * endAngle);
            })
                .onComplete(() => {
                new Tween({ alpha: 0 }).to({ alpha: 1 }, 50)
                    .onUpdate((alpha) => {
                    this.material.opacity = 1 - alpha;
                })
                    .onComplete(() => {
                })
                    .start();
            })
                .start();
        };
        this.init();
    }
    init() {
        this.mainContainer = new Group();
        this.mainContainer.rotation.z = 1.2;
        this.addObject(this.mainContainer);
        this.bigSectors = [];
        this.smallSectors = [];
        const count = 18;
        const theta = Math.PI * 2 / count;
        const geo = new CircleBufferGeometry(this.radius, 2, 0, theta);
        this.material = new MeshBasicMaterial({ color: '#FFFFFF', transparent: true });
        for (let i = 0; i < count - 1; i++) {
            const sector = new Mesh(geo, this.material);
            sector.rotation.z = -i * theta;
            this.bigSectors.push(sector);
            this.mainContainer.add(sector);
        }
        // last part
        const smallGeo = new CircleBufferGeometry(this.radius, 2, 0, theta / 3);
        for (let i = 1; i < 4; i++) {
            const sector = new Mesh(smallGeo, this.material);
            const rot = -16 * theta - i * theta / 3;
            sector.rotation.z = rot;
            this.smallSectors.push(sector);
            this.mainContainer.add(sector);
        }
    }
    updateSectors(angle) {
        this.bigSectors.forEach((sec) => {
            if (angle < -Math.PI * 2 * 16.99 / 18) {
                sec.visible = false;
            }
            if (sec.rotation.z > angle) {
                sec.rotation.z = angle;
            }
        });
        this.smallSectors.forEach((sec) => {
            if (sec.rotation.z > angle) {
                sec.rotation.z = angle;
            }
        });
    }
}
